export const RedirectInitialState = {
  fireRedirect: false,
};

export interface redirectType {
  fireRedirect: boolean;
}
